<template>
    <div class="dateRangeSelection">
        <date-time-range-selection :outer-model="outerModel" @input="onInput"></date-time-range-selection>

        <quick-date-settings
            :outer-model="outerModel"
            @input="onInput"
            :hours="quickSettingHours"
            :hour-formatter="formatQuickSetting"
            keep-minutes
        >
        </quick-date-settings>
    </div>
</template>

<script>
import DateTimeRangeSelection from './DateTimeRangeSelection';
import QuickDateSettings from './QuickDateSettings';

export function createDateRange(from, to) {
    // make <quick-date-settings> dis/enable button correctly:
    // compares Dates exactly (no fuzziness) but sets seconds and ms to 0 (minutes remain because `keep-minutes`)
    to.setSeconds(0);
    to.setMilliseconds(0);
    from.setSeconds(0);
    from.setMilliseconds(0);
    return { from, to };
}

export function createDateRangeLast24h() {
    const now = new Date();
    let yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    return createDateRange(yesterday, now);
}
// Renamed from RidehailingDateRangeSelection
export default {
    name: 'DateRangeSelection',

    components: {
        DateTimeRangeSelection,
        QuickDateSettings
    },

    model: {
        prop: 'outerModel'
    },

    props: {
        // reuse prop definition instead of duplication:
        // eslint-disable-next-line vue/require-default-prop
        outerModel: DateTimeRangeSelection.props.outerModel,
        isValid: {
            // sync
            type: Boolean,
            default: false
        }
    },

    data() {
        const quickSettings = {
            24: '24h',
            168: '7d',
            720: '30d'
        };
        return {
            quickSettings,
            quickSettingHours: Object.keys(quickSettings).map(e => +e)
        };
    },

    computed: {
        isEverythingValid() {
            return this.outerModel.from <= this.outerModel.to;
        }
    },

    watch: {
        isEverythingValid: {
            immediate: true,
            handler(isEverythingValid) {
                this.$emit('update:isValid', isEverythingValid);
            }
        }
    },

    methods: {
        formatQuickSetting(value) {
            return this.quickSettings[value] || value;
        },
        onInput(event) {
            this.$emit('input', event);
        }
    }
};
</script>

<style lang="scss">
.dateRangeSelection {
    margin: 0 auto;
    width: 525px;

    .quickDateSettings {
        margin: 10px 0 0 140px;
    }
}
</style>
